import { gql } from '@apollo/client';
import UPDATE_STUDENT_SETTING_FRAGMENT from '../../fragments/update-student-setting-fragment';

const UPDATE_HWT_STUDENT_LANGUAGE_SETTING = gql`
  mutation updateHwtStudentSettingLanguage($data: [UpdateHwtStudentSettingLocaleInput!]!) {
    updateHwtStudentSettingLanguage(data: $data) {
      ...UpdateStudentSettingFragment
    }
  }
  ${UPDATE_STUDENT_SETTING_FRAGMENT}
`;

export default UPDATE_HWT_STUDENT_LANGUAGE_SETTING;
